// extracted by css-extract-rspack-plugin
export default {"IssueLabelToken":"LabelToken-module__IssueLabelToken__vAY0G"};